<div class="one-column">
    <h1 style="font-weight: 600;">Mitgliedschaften</h1>
    <!-- <h2>Eigene Mitgliedschaften</h2> -->
    <div class="table">
        <div class="row border">
            <p class="closer-to-border"><b>Organisation</b></p>
            <p class="closer-to-border"><b>Rolle</b></p>
        </div>
        <div *ngFor="
                let organisation of userService.currentMemberships
                    | confirmedMembers
            " class="row">
            <div>
                <p class="name-field">{{ organisation.organisationName }}</p>
            </div>
            <div>
                <p *ngIf="organisation.role === 'ADMIN'">Administrator</p>
                <p *ngIf="organisation.role === 'USER'">Benutzer</p>
            </div>
            <div class="center-elements delete-button">
                <red-cross-button (click)="removeOrganisationMembership(organisation.organisationId, organisation.role)"
                    aria-label="Mitgliedschaft entfernen" [text]="'Entfernen'">
                </red-cross-button>
            </div>
        </div>
    </div>

    <div class="table">
        <div class="row border">
            <p class="closer-to-border"><b>Meine offenen Einladungen</b></p>
            <p class="closer-to-border"><b>Rolle</b></p>
        </div>
        <div *ngFor="
                let organisation of userService.currentMemberships
                    | userConfirmationPending
            " class="row">
            <div>
                <p>{{ organisation.organisationName }}</p>
            </div>
            <div>
                <p *ngIf="organisation.role === 'ADMIN'">Administrator</p>
                <p *ngIf="organisation.role === 'USER'">Benutzer</p>
            </div>
            <div class="center-elements">
                <button matButton="elevated" class="acceptButton"
                    (click)="acceptOrganisationMembership(organisation.organisationId)">
                    <mat-icon aria-label="Einladung Annehmen" aria-label="Annehmen">add</mat-icon>
                </button>
            </div>
            <div class="center-elements cancel-button">
                <red-cross-button (click)="removeOrganisationMembership(organisation.organisationId, organisation.role)"
                    aria-label="Einladung entfernen" [text]="'Ablehnen'">
                </red-cross-button>
            </div>
        </div>
        @if ((userService.currentMemberships | userConfirmationPending)?.length === 0) {
        <div class="row">
            <p class="name-field">Es gibt keine offenen Einladungen</p>
        </div>
        }
    </div>
    <br />

    <!-- <div class="table">
        <div class="row border">
            <p class="closer-to-border"><b>Meine offenen Anfragen</b></p>
            <p class="closer-to-border"><b>Rolle</b></p>
        </div>
        <div
            *ngFor="
                let organisation of userService.currentMemberships
                    | adminConfirmationPending
            "
            class="row"
        >
            <div>
                <p>{{ organisation.organisationName }}</p>
            </div>
            <div>
                <p *ngIf="organisation.role === 'ADMIN'">Administrator</p>
                <p *ngIf="organisation.role === 'USER'">Benutzer</p>
            </div>
            <div class="center-elements">
                <p>Bestätigung eines Administrators fehlt</p>
            </div>
            <div class="center-elements">
                <app-hexagon-button-text-icon
                    [text]="'Anfrage löschen'"
                    [icon]="'/assets/img/icons/discard.png'"
                    (click)="
                        removeMembershipRequest(organisation.organisationId)
                    "
                >
                </app-hexagon-button-text-icon>
            </div>
        </div>
    </div> -->
    <div>
        <div class="add-margin">
            <!--             <app-hexagon-button-text-icon [text]="'Antrag auf Mitgliedschaft zu einer Organisation stellen'"
                [icon]="'/assets/img/icons/Organisation_gruenden_dark_blue.png'"
                (click)="onAddOrganisationToggle(); fillOrganisationlist()">
            </app-hexagon-button-text-icon> -->
            <button matButton="elevated" color="accent" type="button" class="width"
                (click)="onAddOrganisationToggle(); fillOrganisationlist();">
                Antrag auf Mitgliedschaft zu einer Organisation stellen
            </button>

        </div>
        <div *ngIf="isUserPlatformAdmin()" class="add-margin">
            <!-- <app-hexagon-button-text-icon [text]="'Organisationen importieren'"
                [icon]="'/assets/img/icons/Organisation_gruenden_dark_blue.png'" (click)="openImportDialog()">
            </app-hexagon-button-text-icon> -->
            <button matButton="elevated" color="accent" type="button" class="width" (click)="openImportDialog()">
                Organisationen importieren
            </button>
        </div>
        <div *ngIf="addOrganisationMode" class="mg-left">
            <p>
                Nachdem der Administrator der Organisation Ihre Mitgliedschaft
                bestätigt hat, sind Sie als Mitglied dieser Organisation eingetragen
            </p>
            <div class="columns-50-50">
                <mat-form-field>
                    <mat-label>Organisation</mat-label>
                    <mat-select [(ngModel)]="addOrganisation.organisationName">
                        <mat-option *ngFor="let organisation of organisations" [value]="organisation.name">{{
                            organisation.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Rolle</mat-label>
                    <mat-select [(value)]="addOrganisation.role">
                        <mat-option [value]="'ADMIN'">Administrator</mat-option>
                        <mat-option [value]="'USER'">Benutzer</mat-option>
                    </mat-select>
                </mat-form-field>
                <div class="columns-50-50">
                    <button matButton="elevated" color="warn" (click)="onCancelAddOrganisation()">
                        Abbrechen
                    </button>
                    <button matButton="elevated" class="green-confirm" (click)="addOrganisationMembership()">
                        Ok
                    </button>
                </div>
            </div>
        </div>
        <div class="add-margin">
            <!--             <app-hexagon-button-text-icon [text]="'Neue Organisation auf der Plattform einstellen'"
                [icon]="'/assets/img/icons/Organisation_gruenden_dark_blue.png'" (click)="newOrganisationModeToggle()">
            </app-hexagon-button-text-icon> -->
            <button matButton="elevated" color="primary" type="button" class="width"
                (click)="newOrganisationModeToggle()">
                Neue Organisation auf der Plattform einstellen
            </button>
        </div>
    </div>

</div>
<app-organisation-edit *ngIf="newOrganisationMode" [organisation]="newOrganisation"
    (close)="newOrganisationModeToggle()">
</app-organisation-edit>

<div *ngIf="isLoading" class="loading-overlay-spinner">
    <mat-spinner></mat-spinner>
</div>
